import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "user-row" }
const _hoisted_2 = { class: "user-row__icon" }
const _hoisted_3 = { class: "user-row__content__column" }
const _hoisted_4 = { class: "user-row__content__column__header" }
const _hoisted_5 = { class: "user-row__content__column__value" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-align-center pr"
}
const _hoisted_7 = {
  class: "user-row__menu",
  ref: "menuRoot"
}
const _hoisted_8 = {
  key: 0,
  class: "user-row__menu-panel"
}
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        class: _normalizeClass(["user-icon", [_ctx.user.status === _ctx.portalStatus.Inactive ? "accent--text" : "primary--text", _ctx.user.roleName === _ctx.userRoles.Support ? "icons8-technical-support" : "icons8-user"]])
      }, null, 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["user-row__content", {"show-company": _ctx.showCompany}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(column.labelKey)), 1),
          _createElementVNode("div", _hoisted_5, [
            (column.translated)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t(column.value)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(column.value), 1)
                ], 64))
          ])
        ]))
      }), 256))
    ], 2),
    (_ctx.canChangeUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "user-row__menu-button",
              type: "button",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop"]))
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "icons8-more" }, null, -1)
            ]))]),
            (_ctx.showMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primaryActions, (item) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: "user-row__menu-item",
                      type: "button",
                      key: item.action,
                      onClick: ($event: any) => (_ctx.showCrudUserSheet(item.action))
                    }, _toDisplayString(_ctx.$t(item.titleKey)), 9, _hoisted_9))
                  }), 128)),
                  _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
                  _createElementVNode("button", {
                    class: "user-row__menu-item mt-05",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCrudUserSheet(_ctx.actions.Delete)))
                  }, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.USER.DELETE')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ]))
      : _createCommentVNode("", true)
  ]))
}